import React from 'react'

const CheckBoxField = ({ list, label, name, value, setCallback, infoKey = '' }) => {

    return (
        <div className='row my-3 justify-content-start'>
            {/* Label */}
            <div className='col-12'>
                <p className='text-primary fw-bold field'>
                    {label}
                </p>
            </div>

            {/* List */}
            <div className='col-12 uw'>
                {list.map((listItem, id) => {
                    return (
                        <div key={id} className="me-3" style={checkBoxText}>
                            <label className="mb-2">
                                <input type="checkbox" style={{ verticalAlign: 'middle' }}
                                    className='form-check-input'
                                    name={`${infoKey ? infoKey + "_" : ""}${name}`}
                                    checked={value.length > 0 ? value.some((veh) => veh?.VIN === listItem?.VIN) : false}
                                    value={listItem?.VIN || ""}
                                    onChange={(e) => setCallback(name, listItem, e.target.checked)}
                                />
                                <span className="ms-3 text-dark">{listItem?.Year + " " + listItem?.Make + " " + listItem?.Model}</span>
                            </label>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

const checkBoxText = {
    fontWeight: 'normal',
    cursor: 'pointer',
    fontSize: '12px'
}

export default CheckBoxField